import { Box, Container, Typography } from "@mui/material";

const reasons = [
  {
    title: "Local-First Discovery",
    desc: "NearbyGuide focuses on places that truly matter in your city — temples, hospitals, parks, malls and essential services.",
    icon: "📍",
  },
  {
    title: "Curated & Reliable",
    desc: "Every place is carefully curated to ensure accurate details, relevance and usefulness for visitors.",
    icon: "✅",
  },
  {
    title: "Simple & Fast",
    desc: "No clutter, no confusion. Find nearby places quickly with a clean and easy-to-use interface.",
    icon: "⚡",
  },
  {
    title: "Built for Everyday Needs",
    desc: "From daily essentials to weekend outings, NearbyGuide helps you discover places effortlessly.",
    icon: "🌍",
  },
];

const WhyNearbyGuide = () => {
  return (
    <Box
      sx={{
        position: "relative",
        backgroundColor: "#FFFFFF",
        py: { xs: 5, md: 7 },
        borderTop: "1px solid rgba(13,59,102,0.06)",
      }}
    >
      <Container>
        {/* ===== HEADER ===== */}
        <Box sx={{ mb: 4, maxWidth: 620 }}>
          <Typography
            component="h2"
            sx={{
              fontSize: { xs: "1.7rem", md: "2.2rem" },
              fontWeight: 800,
              color: "var(--color-neon, #0D3B66)",
              letterSpacing: "-0.4px",
            }}
          >
            Why{" "}
            <Box component="span" sx={{ color: "#F4D35E" }}>
              NearbyGuide
            </Box>
          </Typography>

          <Typography
            sx={{
              mt: 1,
              color: "rgba(13,59,102,0.7)",
              fontSize: "0.95rem",
              lineHeight: 1.6,
            }}
          >
            NearbyGuide is designed to help you discover trusted places near you
            with clarity, confidence, and ease.
          </Typography>
        </Box>

        {/* ===== REASONS (FLEXBOX ONLY) ===== */}
        <Box
          sx={{
            display: "flex",
            flexWrap: "wrap",
            gap: { xs: 2, md: 3 },
          }}
        >
          {reasons.map((item, index) => (
            <Box
              key={index}
              sx={{
                flex: {
                  xs: "1 1 100%",
                  sm: "1 1 calc(50% - 16px)",
                  md: "1 1 calc(25% - 24px)",
                },
                backgroundColor: "#FFFDF7",
                borderRadius: 3,
                p: { xs: 2.5, md: 3 },
                border: "1px solid rgba(13,59,102,0.08)",
                boxShadow: "0 10px 24px rgba(0,0,0,0.06)",
                transition: "transform 0.3s ease, box-shadow 0.3s ease",
                "&:hover": {
                  transform: { md: "translateY(-6px)" },
                  boxShadow: "0 18px 40px rgba(13,59,102,0.18)",
                },
              }}
            >
              {/* ICON */}
              <Box
                sx={{
                  fontSize: "2.2rem",
                  mb: 1.5,
                }}
              >
                {item.icon}
              </Box>

              {/* TITLE */}
              <Typography
                sx={{
                  fontWeight: 700,
                  color: "var(--color-neon, #0D3B66)",
                  fontSize: "1.05rem",
                  mb: 0.6,
                }}
              >
                {item.title}
              </Typography>

              {/* DESCRIPTION */}
              <Typography
                sx={{
                  fontSize: "0.9rem",
                  color: "rgba(13,59,102,0.7)",
                  lineHeight: 1.6,
                }}
              >
                {item.desc}
              </Typography>
            </Box>
          ))}
        </Box>
      </Container>
    </Box>
  );
};

export default WhyNearbyGuide;
